import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';


export const PodCastWrapper = styled.div`
  position: relative;
`
